var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWmiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logoMark-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-1",
    d: "M299.5,323.3h0c-41.8-.1-75.7-34.1-75.5-76,.1-41.6,33.8-75.4,75.5-75.5h0c41.8.1,75.6,34.2,75.5,76-.1,41.6-33.8,75.4-75.5,75.5h0ZM299.4,179.4h0c-37.6,0-68.1,30.5-68,68.1s30.5,68.1,68.1,68h0c37.6,0,68.1-30.5,68.1-68.1,0-37.6-30.5-68.1-68.1-68.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_-9",
    d: "M500,222.7h-68.9c-21.4,0-34.5-14.3-48.4-29.4-18-19.7-38.5-42-83.2-42s-67.4,22.4-87.2,42.2c-15.1,15.1-29.4,29.3-50.7,29.3h-61.6v-7.7h61.6c18.1,0,30.7-12.5,45.3-27,19.9-19.8,44.6-44.4,92.6-44.4s70.8,24.7,88.9,44.5c13.2,14.4,24.7,26.9,42.7,26.9h68.9v7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_2-6",
    d: "M299.5,350.4c-48,0-72.8-24.1-92.6-43.5-14.6-14.2-27.1-26.5-45.3-26.5h-61.6v-7.7h61.6c21.3,0,35.5,13.9,50.6,28.7,19.8,19.4,42.3,41.3,87.2,41.3s65.2-21.9,83.3-41.2c13.8-14.8,26.9-28.8,48.3-28.8h68.9v7.7h-68.9c-18.1,0-29.5,12.2-42.7,26.4-18.2,19.4-40.7,43.6-88.9,43.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_3-9",
    d: "M498.8,164.8h-67.7c-16.7,0-30.3-6.6-46.1-14.2-21.6-10.5-46-22.3-87.5-22.3s-67.2,11.9-89.6,22.5c-16.1,7.6-30.1,14.1-46.3,14.1h-61.6v-7.7h61.6c14.5,0,27.7-6.2,43-13.3,22.1-10.3,49.5-23.2,92.9-23.2s69.6,12.8,90.8,23.1c14.9,7.2,27.8,13.5,42.7,13.5h67.7v7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_4-3",
    d: "M299.5,374.9c-43.4,0-71.5-13-94.1-23.5-15.7-7.3-29.2-13.5-43.8-13.5h-61.6v-7.7h61.6c16.2,0,30.5,6.6,47,14.2,23.1,10.7,49.2,22.7,90.9,22.7s65.2-12,86.2-22.6c15.4-7.7,28.7-14.4,45.4-14.4h68.9v7.7h-68.9c-14.9,0-27.4,6.3-41.9,13.6-20.7,10.4-46.4,23.4-89.7,23.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "logoMark_PathItem_5-3",
    x: 100,
    y: 100,
    width: 398.8,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "logoMark_PathItem_6-8",
    x: 100,
    y: 387.3,
    width: 398.8,
    height: 7.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g962-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6326",
    d: "M105.6,440.2h0c-.7,0-1.2.1-1.5.4-.3.2-.4.6-.4,1.1l.2.6,44,156.1c.4,1.1,1.1,1.6,2.2,1.6h11.5c.7,0,1.2-.2,1.6-.4.3-.3.6-.7.6-1.3h0s32.8-128.4,32.8-128.4h0c0-.2.2-.3.3-.5.1-.1.3-.2.5-.2.4,0,.8.3,1,.6h0s33.5,128.4,33.5,128.4h0c.1.6.4,1.1.7,1.4.4.3.8.4,1.5.4h12.1c.6,0,1.1-.1,1.5-.4.4-.3.6-.6.7-1.2h0s43.3-156.1,43.3-156.1c.1-.7,0-1.2-.4-1.5h0s0,0,0,0c-.2-.4-.6-.5-1.3-.5h-11.7c-.6,0-1.1.1-1.5.4-.4.3-.6.6-.7,1.2h0s-34.8,125.7-34.8,125.7h0c-.2.4-.6.7-1,.7s-.3,0-.5-.2c-.1-.1-.2-.3-.3-.4h0s-33.7-125.4-33.7-125.4h0c-.1-.6-.4-1.1-.7-1.4-.4-.3-.8-.4-1.5-.4h-12.4c-.6,0-1.1.2-1.5.4-.4.3-.6.7-.7,1.4h0s-32.3,125.4-32.3,125.4h0c-.2.4-.6.7-1,.7s-.3,0-.5-.2c-.1-.1-.2-.3-.3-.4h0s-34.9-125.7-34.9-125.7h0c-.1-.6-.4-.9-.7-1.2-.4-.3-.8-.4-1.5-.4h-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6320",
    d: "M320.5,440.2c-.7,0-1.2.2-1.5.5-.3.3-.5.8-.5,1.5v155.9c0,.7.2,1.2.5,1.5.3.3.8.5,1.5.5h11.7c.7,0,1.2-.2,1.5-.5.3-.3.5-.8.5-1.5v-126.8c0-.5.2-1,.6-1.2.2-.1.5-.1.7,0,.2.1.3.3.4.6l37.3,56.8c.7.9,1.5,1.3,2.5,1.3h6c1,0,1.8-.5,2.5-1.5l37.3-57.3c0-.2.2-.4.4-.6.2-.1.5-.1.7,0,.4.2.6.7.6,1.2v127.4c0,.7.2,1.2.5,1.5.3.3.8.5,1.5.5h11.7c.7,0,1.2-.2,1.5-.5.3-.3.5-.8.5-1.5v-155.9c0-.7-.2-1.2-.5-1.5-.3-.3-.8-.5-1.5-.5h-11.9c-1,0-1.8.5-2.5,1.5l-42.6,65.1h0c-.2.3-.6.3-.9.3s-.7,0-.9-.3h0s-43.1-65.4-43.1-65.4c-.6-.8-1.3-1.2-2.5-1.2h-11.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path4336-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6314",
    d: "M480.8,440.2c-.7,0-1.2.2-1.5.5s-.5.8-.5,1.5v155.9c0,.7.2,1.2.5,1.5.3.3.8.5,1.5.5h11.7c.7,0,1.2-.2,1.5-.5.3-.3.5-.8.5-1.5v-155.9c0-.7-.2-1.2-.5-1.5s-.8-.5-1.5-.5h-11.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path1089",
    d: "M298.6,210.7c-10.1,0-18.8,3.6-26,10.7h0s0,0,0,0c-7.1,7.2-10.7,15.9-10.7,26s3.6,18.8,10.7,26h0c7.2,7.1,15.9,10.7,26,10.7s15-2.2,21-6.6l6.2,6.2,7.3-7.3-6-6c5.4-6.4,8.2-14.1,8.2-23s-3.6-18.8-10.7-26h0c-7.2-7.1-15.9-10.7-26-10.7h0ZM298.6,220.9c7.3,0,13.5,2.6,18.7,7.7,5.2,5.2,7.7,11.4,7.7,18.7s-1.8,11.5-5.3,15.8l-6.9-6.9-7.3,7.3,6.6,6.6c-3.8,2.5-8.3,3.8-13.6,3.8s-13.5-2.6-18.7-7.7h0c-5.2-5.2-7.7-11.4-7.7-18.7s2.6-13.5,7.7-18.7c5.2-5.2,11.4-7.7,18.7-7.7h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWmiLogo);
export default __webpack_public_path__ + "static/media/wmi-logo.43ce08f84f3c1d0e247487e903f2f9f0.svg";
export { ForwardRef as ReactComponent };